import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import "./reports.css"
import { BarLoader } from 'react-spinners';
import { TfiEmail } from "react-icons/tfi";
import { HiOutlinePrinter } from "react-icons/hi2";
import { PiDownloadSimple } from "react-icons/pi";
import moment from 'moment';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { jsPDF } from 'jspdf';
import { BsFileEarmarkPdf, BsFiletypeCsv } from "react-icons/bs";
import 'jspdf-autotable';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import AsyncSelect from 'react-select/async';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { LiaFileExcel } from "react-icons/lia";
import * as XLSX from "xlsx";
import { useLocation } from "react-router-dom";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const PurchaseOrderReports = () => {
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [StockType, setStockType] = useState();
    const [SupplierList, setSuppliers] = useState();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [dateFilter, setdateFilter] = useState(false);
    const currentDatetimeUTC = new Date().toISOString().slice(0, 16);
    const gridRef = useRef();
    const apiService = new ApiService();
    const { precision } = useCurrency();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const onOpenModal = () => setEmailModal(true);
    const onCloseModal = () => setEmailModal(false);
    const [cost1, setCost1] = useState([]);
    const [cost2, setCost2] = useState([]);
    const [cost2main, setCost2main] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const location = useLocation();
    const dashboardFilters = location.state || {};

    const StatusFilter = [
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Approved' },
        { value: '4', label: 'Hold' },
        { value: '2', label: 'Rejected' },
        { value: '3', label: 'Cancelled' },
    ];
    const FilterStatus = [
        { value: 'Partially Delivered', label: 'Partial Delievered' },
        { value: 'Completely Delivered', label: 'Completely Delivered' },
        { value: 'Not Delivered', label: 'Not Delivered' }
    ];
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const [formData, setFormData] = useState({
        email: "",
        PoNum: "",
        fromDate: '',          // Today's date
        toDate: '',
        Filterby: [{ label: 'Select Delivery Status', value: '0' }],
        VendorName: [{ label: 'Select Supplier ', value: '0' }],
        StockType: [{ label: 'Select Stock Type', value: '0' }],
        Status: [{ label: 'Filter By', value: '' }],
        ItemType: [{ label: 'Select Stock Type', value: '0' }],
        itemNo: { label: 'Select ItemNo', value: 'All' },
        ItemDescription: { label: 'Select Item', value: 'All' },
        costCenter1: [{ label: 'Select Property', value: "" }],
        costCenter2: [{ label: 'Select Unit', value: "" }],
    });
    const handleClearFilters = () => {
        setFormData({
            PoNum: "",
            fromDate: '',          // Today's date
            toDate: '',
            Filterby: [{ label: 'Select Delivery Status', value: '0' }],
            VendorName: [{ label: 'Select Supplier ', value: '0' }],
            StockType: [{ label: 'Select Stock Type', value: '0' }],
            Status: [{ label: 'Filter By', value: '' }],
            ItemType: [{ label: 'Select Stock Type', value: '0' }],
            itemNo: { label: 'Select ItemNo', value: 'All' },
            ItemDescription: { label: 'Select Item', value: 'All' },
            costCenter1: [{ label: 'Select Property', value: "" }],
            costCenter2: [{ label: 'Select Unit', value: "" }],
        });
        setCost2(cost2main)
        setdateFilter(false)
    };

    useEffect(() => {
        const today = new Date();
        const selectedStatus = StatusFilter?.find((acc) => acc?.label === dashboardFilters?.status);
        setFormData((prev) => ({
            ...prev,
            fromDate: formatDate(dashboardFilters?.fromDate) || formatDate(today),
            toDate: formatDate(dashboardFilters?.toDate) || formatDate(today),
            Status: selectedStatus || ''
        }));
        const getData = async (newPageNo = pagination?.currentPage) => {
            try {

                const params = new URLSearchParams();
                params.append('VendorName', formData.VendorName.label || "");
                const apiService = new ApiService();
                params.append('Status', selectedStatus?.value || "");
                params.append('Filter', formData.Filterby.value || "");
                params.append('ItemDescription', formData.Items?.label || "");
                params.append('CostCenter1', formData.costCenter1?.label || "");
                params.append('CostCenter2', formData.costCenter2?.label || "");
                params.append('StockType', formData.StockType?.value?.stockTypeCode || "");
                params.append('PageNo', newPageNo || 1);
                params.append('PageSize', pageSize || 20);
                params.append('POrderNo', formData.PoNum || "");
                params.append('FromDate', formatDate(dashboardFilters?.fromDate) || formatDate(today) || formData?.fromDate || "");
                params.append('ToDate', formatDate(dashboardFilters?.toDate) || formatDate(today) || formData?.toDate || "");
                const res = await apiService.getApiParamater('GET_PO_REPORT', `?${params.toString()}`);
                setRowData(res.data.result?.reverse() || []);
                setPagination(res.data.paginationData);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching items:', error);
                setLoading(false);
            }
        }
        getData(1)
    }, []);

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const apiService = new ApiService();
                let param = `?isActive=true`
                const stockType = await apiService.getApiParamater("GET_STOCK_TYPE", param);
                setStockType(stockType?.data?.result);
                const suppliers = await apiService.get('GET_SUPPLIER_KANOO');
                setSuppliers(suppliers?.data?.result);
                let cost1 = await apiService.get('GET_COST_ONE')
                setCost1([{ value: null, description: 'None' }, ...cost1.data.result]);
                let cost2 = await apiService.get('GET_COST_TWO')
                setCost2([{ value: null, description: 'None' }, ...cost2.data.result]);
                setCost2main([{ value: null, description: 'None' }, ...cost2.data.result]);
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        fetchDropdownData();
    }, []);

    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);

    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemNo', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemDescription', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async () => {
        if (!hasMore || loader) return;
        setPage(prevPage => prevPage + 1);
        await fetchItemNo("", page + 1);
    };
    const loadMoreDescOptions = async () => {
        if (!hasMore || loader) return;
        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc("", desPage + 1);
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('VendorName', formData.VendorName.label || "");
            params.append('Status', formData.Status.value || "");
            params.append('Filter', formData.Filterby.value || "");
            params.append('ItemDescription', formData.Items?.label || "");
            params.append('CostCenter1', formData.costCenter1?.label || "");
            params.append('CostCenter2', formData.costCenter2?.label || "");
            params.append('StockType', formData.StockType?.value?.stockTypeCode || "");
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('POrderNo', formData.PoNum || "");
            if (dateFilter === true) {
                params.append('FromDate', formData?.fromDate || "");
                params.append('ToDate', formData?.toDate || "");
            }

            const res = await apiService.getApiParamater('GET_PO_REPORT', `?${params.toString()}`);
            setRowData(res?.data?.result?.reverse() || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const dateFormatter = (params) => {
        const date = moment.utc(params.value || currentDatetimeUTC).local();
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const Comparison = [
        { headerName: 'PO No', field: 'pOrderNo', suppressMovable: true, width: 110 },
        { headerName: 'Qout Ref', field: 'quotationRef', suppressMovable: true, width: 110 },
        { headerName: 'Requisition NO ', field: 'requisitionNo', suppressMovable: true, width: 110, },
        {
            headerName: 'PO Date', field: 'docDate', suppressMovable: true, width: 130, filter: 'agDateColumnFilter',
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Vendor', field: 'vendorName', suppressMovable: true, width: 110 },
        { headerName: 'Payment Term', field: 'terms', suppressMovable: true, width: 110 },
        { headerName: 'Supplier Contact', field: 'attention', suppressMovable: true, width: 110 },
        { headerName: 'Department', field: 'department', suppressMovable: true, width: 110 },
        {
            headerName: 'Delivery Date', field: 'deliveryDate', suppressMovable: true, width: 150, filter: 'agDateColumnFilter',
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Curr Code', field: 'currencyCode', suppressMovable: true, width: 110 },
        { headerName: 'Exchange Rate', field: 'exchangeRate', suppressMovable: true, width: 110 },
        {
            headerName: 'Status', field: 'status', suppressMovable: true, width: 110,
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<div>Pending</div>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<div>Approved</div>);
                }
                else if (params.value === 5 || params.value === null) {
                    return (<div>Hold</div>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<div>Rejected</div>);
                } else {
                    return params.value;
                }
            }
        },
        { headerName: 'Cost center 1', field: 'costCenter1', suppressMovable: true, width: 110 },
        { headerName: 'Cost center 2', field: 'costCenter2', suppressMovable: true, width: 110 },
        { headerName: 'Cost center 3', field: 'costCenter3', suppressMovable: true, width: 110 },
        { headerName: 'Cost center 4', field: 'costCenter4', suppressMovable: true, width: 110 },
        { headerName: 'Delivery Status', field: 'deliveryStatus', suppressMovable: true, width: 110 },
        { headerName: 'Item Code', field: 'itemCode', suppressMovable: true, width: 110 },
        { headerName: 'Item Description', field: 'itemDescription', suppressMovable: true, width: 300 },
        { headerName: 'UOM', field: 'uom', suppressMovable: true, width: 110 },
        { headerName: 'QTY', field: 'qty', suppressMovable: true, width: 110 },
        {
            headerName: 'Unit Price', field: 'unitPrice', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(precision?.precision || 0)
        },
        { headerName: 'Vat %', field: 'vatPerc', suppressMovable: true, width: 110 },
        {
            headerName: 'Vat Amount', field: 'vatAmount', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(precision?.precision || 0)
        },
        {
            headerName: 'Amount', field: 'amount', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(precision?.precision || 0)
        },
        {
            headerName: 'Net Amount', field: 'netAmount', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(precision?.precision || 0)
        },
        { headerName: 'GRN Qty', field: 'grnQty', suppressMovable: true, width: 110 },

    ];
    const onBtnCSVExport = useCallback(() => {
        gridRef.current.api.exportDataAsCsv({
            fileName: 'PurchaseOrderReport.csv'
        });
    }, []);
    const onBtPDFExport = useCallback(() => {
        const doc = new jsPDF();
        const rowData = [];
        const columnHeaders = [];
        const comparisonFields = [
            'recordId',
            'requisitionNo',
            'docDate',
            'vendorName',
            'terms',
            'status',
            'deliveryDate',
            'deliveryStatus',
            'itemCode',
            'itemDescription',
            'uom',
            'qty',
            'unitPrice',
        ];

        const translateStatus = (status) => {
            switch (status) {
                case 1:
                    return 'Approved';
                case 0:
                    return 'Pending';
                case 2:
                    return 'Hold';
                case 3:
                    return 'Rejected';
                default:
                    return status;
            }
        };

        comparisonFields.forEach(field => {
            const header = Comparison.find(col => col.field === field).headerName;
            columnHeaders.push(header);
        });

        gridRef.current.api.forEachNode((node) => {
            const row = [];
            comparisonFields.forEach(field => {
                let value = node.data[field];
                if (field === 'status') {
                    value = translateStatus(value);
                }
                row.push(value);
            });
            rowData.push(row);
        });

        const poppinsFont = 'data:font/ttf;base64,AAEAAAARAQAABAAw7HA...';
        doc.addFileToVFS("Poppins-Regular.ttf", poppinsFont);
        doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
        doc.setFont("Poppins");
        doc.setFontSize(18);
        doc.setTextColor(40, 40, 40);
        doc.text("Purchase Order Report", 72, 12);
        doc.text("__________________________", 60, 15);
        doc.autoTable({
            head: [columnHeaders],
            body: rowData,
            styles: {
                fontSize: 5,
            },
            headStyles: {
                fillColor: [209, 126, 6],
                textColor: [255, 255, 255],
                fontSize: 5,
            },
            columnStyles: {
                0: { cellWidth: 15 },
                1: { cellWidth: 15 },
                2: { cellWidth: 15 },
                3: { cellWidth: 15 },
                4: { cellWidth: 15 },
                5: { cellWidth: 15 },
                6: { cellWidth: 15 },
                7: { cellWidth: 20 },
                8: { cellWidth: 15 },
                9: { cellWidth: 15 },
                10: { cellWidth: 10 },
                11: { cellWidth: 10 },
                12: { cellWidth: 10 },
            },
            startY: 20
        });

        doc.save('PurchaseOrderReport.pdf');
    }, []);
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleDateFilterSelection = (e) => {
        setdateFilter(e);
    };
    const SendEmail = async () => {
        try {
            if (!formData.email) {
                toast.warning("Enter User Email to send Report")
                return;
            }
            const requestBody = {
                // toEmail: "shahzaibawan864@gmail.com",
                toEmail: formData.email,
                subject: "Purchase Order Report",
                body: `
                <div className='printhead2 mb-5 px-4'>
                    <table>
                        <thead className='dynoTable' style='background-color: #5B93FF; color: #fff;'>
                            <tr>
                                <th>PO No</th>
                                <th>Requisition NO </th>
                                <th>PO Date</th>
                                <th>Vendor</th>
                                <th>Payment Term</th>
                                <th>Supplier Contact</th>
                                <th>Department</th>
                                <th>Curr Code</th>
                                <th>status</th>
                                <th>Cost center 1</th>
                                <th>Cost center 2</th>
                                <th>Cost center 3</th>
                                <th>Cost center 4</th>
                                <th>Delivery Status</th>
                                <th>Item Code</th>
                                <th>Item Description</th>
                                <th>UOM</th>
                                <th>QTY</th>
                                <th>Unit Price</th>
                                <th>Vat %</th>
                                <th>Vat Amount</th>
                                <th>Amount</th>
                                <th>Net Amount</th>
                                <th>GRN Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rowData?.map((row, index) => `
                                <tr key=${index}>
                                    <td className='m-0 p-0'><input style='width: 100px;' className='p-2' type='text' value='${row.pOrderNo}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.requisitionNo}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.docDate}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.vendorName}' /></td>
                                    <td className='m-0 p-0'><input style='width: 80px;' className='p-2' disabled value='${row.terms}' /></td>
                                    <td className='m-0 p-0'><input style='width: 150px;' className='p-2' disabled value='${row.attention}' /></td>
                                    <td className='m-0 p-0'><input style='width: 120px;' className='p-2' disabled value='${row.department}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.currencyCode}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.status}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter1}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter2}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter3}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter4}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.deliveryStatus}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.itemCode}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.itemDescription}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.uom}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.qty}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.unitPrice}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.vatPerc}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.vatAmount}' disabled /></td>
                                    <td className='m-0 p-0'><input className='p-2 w-100' type='text' value='${row.amount?.toFixed(precision?.precision || 0) || 0}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.netAmount}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.grnQty}' disabled /></td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>`
            }
            const apiService = new ApiService();
            const response = await apiService.post("SEND_EMAIL", requestBody);
            if (response.status === 200) {
                onCloseModal()
                toast.success("Email send successfully")
                handleClearFilters()
            }

        } catch (error) {
            console.error('Error:', error);
        }
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "itemNo" || name === "ItemDescription") {
            setFormData({
                ...formData,
                itemNo: value ? { label: value.value.itemNo, value: value.value } : null,
                ItemDescription: value ? { label: value.value.itemDescription, value: value.value } : null,
            });
        } else if (name === "costCenter1") {
            let param = `?CostCenter1=${value?.label}`
            let cost2 = await apiService.getApiParamater('GET_COST_TWO', param)
            setFormData(prev => ({ ...prev, [name]: value }));
            if (cost2?.data?.result) {
                setCost2([{ value: null, description: 'None' }, ...cost2?.data?.result]);
            } else {
                setCost2([])
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };
    const onBtnExcelExport = useCallback(async (formdata, pagedata) => {
        try {
            setLoading(true);

            const params = new URLSearchParams();
            params.append('VendorName', formdata.VendorName.label || "");
            params.append('Status', formdata.Status.value || "");
            params.append('Filter', formdata.Filterby.value || "");
            params.append('ItemDescription', formdata.Items?.label || "");
            params.append('CostCenter1', formdata.costCenter1?.label || "");
            params.append('CostCenter2', formdata.costCenter2?.label || "");
            params.append('StockType', formdata.StockType?.value?.stockTypeCode || "");
            params.append('POrderNo', formdata.PoNum || "");
            if (dateFilter === true) {
                params.append('FromDate', formdata?.fromDate || "");
                params.append('ToDate', formdata?.toDate || "");
            }

            params.append("PageNo", 1);
            params.append(
                "PageSize",
                pagedata?.totalRecords || 10000
            );

            const res = await apiService.getApiParamater(
                "GET_PO_REPORT",
                `?${params.toString()}`
            );

            const allData = res?.data?.result || [];

            if (!allData.length) {
                toast.info("No data found");
                return;
            }

            // ============================================================
            // TOTAL AMOUNT
            // ============================================================

            const totalAmount = allData.reduce(
                (sum, item) => {
                    return sum + Number(item.itemAmount || 0);
                },
                0
            );

            // ============================================================
            // NET AMOUNT SUM
            // ============================================================

            const totalNetAmount = allData.reduce(
                (sum, item) => {
                    return sum + Number(item.netAmount || 0);
                },
                0
            );

            // ============================================================
            // NET AMOUNT COUNT
            // Count rows having a Net Amount value
            // ============================================================

            const netAmountCount = allData.filter(
                (item) =>
                    item.netAmount !== null &&
                    item.netAmount !== undefined &&
                    item.netAmount !== ""
            ).length;

            // ============================================================
            // EXCEL DATA
            // ============================================================

            const excelData = allData.map((item) => ({
                "PO No": item.pOrderNo || "",
                "Qout Ref": item.quotationRef || "",
                "Requisition NO": item.requisitionNo || "",

                "PO Date": item.docDate
                    ? moment(item.docDate).format("DD-MMM-YYYY")
                    : "",

                "Vendor": item.vendorName || "",
                "Payment Term": item.terms || "",
                "Supplier Contact": item.attention || "",
                "Department": item.department || "",

                "Delivery Date": item.deliveryDate
                    ? moment(item.deliveryDate).format("DD-MMM-YYYY")
                    : "",

                "Curr Code": item.currencyCode || "",
                "Exchange Rate": item.exchangeRate || 0,

                "Status":
                    item.status === 1
                        ? "Approved"
                        : item.status === 0
                            ? "Pending"
                            : item.status === 5
                                ? "Hold"
                                : "Rejected",

                "Property": item.costCenter1 || "",
                "Unit": item.costCenter2 || "",
                "Delivery Status": item.deliveryStatus || "",
                "Item Code": item.itemCode || "",
                "Item Description": item.itemDescription || "",
                "UOM": item.uom || "",

                "QTY": item.qty || 0,

                "Unit Price": Number(item.unitPrice || 0).toFixed(4),

                "Vat %": item.vatPerc || 0,

                "Vat Amount": Number(
                    item.itemVatAmount || 0
                ).toFixed(precision || 3),

                "Amount": Number(
                    item.itemAmount || 0
                ).toFixed(precision || 3),

                "Net Amount": Number(
                    item.netAmount || 0
                ).toFixed(precision || 3),

                "GRN Qty": item.grnQty || 0,

                "GRN Balance Qty": (
                    Number(item.qty || 0) -
                    Number(item.grnQty || 0)
                ).toFixed(3)
            }));

            // ============================================================
            // EMPTY ROW FOR SPACING
            // ============================================================

            excelData.push({});

            // ============================================================
            // TOTAL ROW
            // ============================================================

            const totalRow = {
                "PO No": "",
                "Qout Ref": "",
                "Requisition NO": "",
                "PO Date": "",
                "Vendor": "",
                "Payment Term": "",
                "Supplier Contact": "",
                "Department": "",
                "Delivery Date": "",
                "Curr Code": "",
                "Exchange Rate": "",
                "Status": "",
                "Property": "",
                "Unit": "",
                "Delivery Status": "",
                "Item Code": "",
                "Item Description": "",
                "UOM": "",
                "QTY": "",
                "Unit Price": "",
                "Vat %": "",

                "Vat Amount": "Total",

                "Amount": Number(
                    totalAmount || 0
                ).toFixed(precision || 3),

                // Net Amount Sum + Count
                "Net Amount": `Sum: ${Number(
                    totalNetAmount || 0
                ).toFixed(precision || 3)} | Count: ${netAmountCount}`,

                "GRN Qty": "",
                "GRN Balance Qty": ""
            };

            excelData.push(totalRow);

            // ============================================================
            // CREATE WORKSHEET
            // ============================================================

            const worksheet = XLSX.utils.json_to_sheet(excelData);

            // ============================================================
            // AUTO-FIT COLUMN WIDTHS
            // ============================================================

            const headers = Object.keys(excelData[0]);

            const columnWidths = headers.map((header) => {

                // Give Item Description more space
                if (header === "Item Description") {
                    return {
                        wch: 60
                    };
                }

                // Give Net Amount enough space for Sum + Count
                if (header === "Net Amount") {
                    return {
                        wch: 35
                    };
                }

                const maxLength = Math.max(
                    header.length,
                    ...excelData.map((row) => {
                        const value = row[header];

                        return value !== null &&
                            value !== undefined
                            ? value.toString().length
                            : 0;
                    })
                );

                return {
                    wch: Math.min(
                        Math.max(maxLength + 2, 10),
                        40
                    )
                };
            });

            worksheet["!cols"] = columnWidths;

            // ============================================================
            // TOTAL ROW STYLE
            // ============================================================

            const totalRowStyle = {
                font: {
                    bold: true
                },
                fill: {
                    fgColor: {
                        rgb: "E0E0E0"
                    }
                }
            };

            // ============================================================
            // APPLY TOTAL ROW STYLE
            // ============================================================

            const range = XLSX.utils.decode_range(
                worksheet["!ref"]
            );

            // Excel row index:
            // Header = row 0
            // Data rows
            // Empty row
            // Total row = last row
            const totalRowIndex = excelData.length;

            for (
                let C = range.s.c;
                C <= range.e.c;
                ++C
            ) {
                const cellAddress = XLSX.utils.encode_cell({
                    r: totalRowIndex,
                    c: C
                });

                if (worksheet[cellAddress]) {
                    worksheet[cellAddress].s = totalRowStyle;
                }
            }

            // ============================================================
            // CREATE WORKBOOK
            // ============================================================

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Purchase Order Report"
            );

            // ============================================================
            // DOWNLOAD EXCEL
            // ============================================================

            XLSX.writeFile(
                workbook,
                "POReport.xlsx"
            );

            toast.success(
                "POReport.xlsx downloaded"
            );

        } catch (err) {
            console.log("Excel Export Error:", err);

            toast.error(
                "Something went wrong"
            );

        } finally {
            setLoading(false);
        }
    }, [precision]);
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-9'>
                    <div className='row' >
                        <div className='col'>
                            <input
                                type='text'
                                className="form-Input w-100"
                                placeholder='POrder No'
                                value={formData.PoNum}
                                name="PoNum"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Status}
                                options={StatusFilter}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'Status', value: selectedOption })}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Filterby}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'Filterby', value: selectedOption })}
                                options={FilterStatus}
                            />
                        </div>
                    </div>
                    <div className='row py-2'>
                        <div className='col'>
                            <AsyncSelect
                                cacheOptions
                                value={formData.itemNo}
                                options={itemOptions}
                                loadOptions={loadOptions}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'itemNo', value: selectedOption })}
                                defaultOptions={itemOptions}
                                onMenuScrollToBottom={loadMoreOptions}
                            />
                        </div>
                        <div className='col'>
                            <AsyncSelect
                                cacheOptions
                                value={formData.ItemDescription}
                                options={descriptionOptions}
                                loadOptions={loadDescOptions}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'ItemDescription', value: selectedOption })}
                                className="w-100 p-0"
                                defaultOptions={descriptionOptions}
                                onMenuScrollToBottom={loadMoreDescOptions}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.VendorName}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'VendorName', value: selectedOption })}
                                options={SupplierList?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.StockType}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'StockType', value: selectedOption })}
                                options={StockType?.map((Stock) => ({ value: Stock, label: Stock?.stockTypeName }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.costCenter1}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter1', value: selectedOption })}
                                options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.costCenter2}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'costCenter2', value: selectedOption })}
                                options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                            />
                        </div>
                    </div>
                    <div className='row pt-2'>
                        <div className='col gap-3 center'>
                            <input className="form-check-input"
                                type="checkbox"
                                id="dateFilter" style={{ width: "20px", height: "20px" }}
                                name="dateFilter"
                                checked={dateFilter}
                                onChange={(e) => handleDateFilterSelection(e.target.checked)} />
                            <label className=''>Date Filter</label>
                        </div>

                        <div className="d-flex justify-content-between start col">
                            <DatePicker
                                selected={formData.fromDate}
                                disabled={!dateFilter}
                                onChange={(date) => handleDateChange({ name: 'fromDate', value: date })}
                                className="p-2 form-Input w-100"
                                dateFormat="dd-MM-yyyy"
                            />
                        </div>
                        <div className="d-flex justify-content-between start col">
                            <DatePicker
                                selected={formData.toDate}
                                onChange={(date) => handleDateChange({ name: 'toDate', value: date })}
                                className="p-2 form-Input w-100"
                                disabled={!dateFilter}
                                dateFormat="dd-MM-yyyy"
                            />
                        </div>
                    </div>
                </div>
                <div className='col-3 '>
                    <div onClick={() => getItems()} className='mainbtnGry flex-end gap-2'>
                        <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Search</div>
                    </div>
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Purchase Order Report</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtnGry flex-end gap-2'>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={onBtnCSVExport} className='gap-3 d-flex center'><BsFiletypeCsv /><div>Export CSV</div></DropdownItem>
                                <DropdownItem onClick={() => onBtnExcelExport(formData, pagination)} className='gap-3 d-flex center'><LiaFileExcel /><div>Export Excel</div></DropdownItem>
                                <DropdownItem onClick={onBtPDFExport} className='gap-3 d-flex center'><BsFileEarmarkPdf /><div>Export PDF</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div className='mainbtnRed flex-end '><HiOutlinePrinter size={25} /></div>
                    <div className='mainbtn flex-end gap-1' onClick={onOpenModal}>
                        <div className='center'><TfiEmail size={25} /></div>
                    </div>
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 550 }}>
                    {loading === true ?
                        <div className="center p-5">
                            <BarLoader color="#6E5199" height={3} width={200} />
                        </div>
                        :
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            enableFilter={true}
                            floatingFilter={true}
                            rowSelection={'single'}
                            columnDefs={Comparison}
                            suppressExcelExport={true}
                            ref={gridRef}
                        />
                    }
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
            <Modal size="md"
                show={emailModal} onHide={() => onCloseModal()}
                onRequestClose={() => onCloseModal()}
                contentLabel='Email Modal'
                style={customStyles} closeButton
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>Send Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <input
                            type='email'
                            className="form-Input w-100"
                            id="validationCustom02"
                            value={formData.email}
                            name="email"
                            onChange={handleInputChange}
                            placeholder='Enter Email'
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Close</button>
                    <button className='mainbtnRed' onClick={SendEmail} >Save</button>
                </Modal.Footer>
            </Modal >
        </div>
    );
};
export default PurchaseOrderReports;
const customStyles = {
    content: {
        width: '30%', // Set the desired width
        height: '75%', // Set the desired 
        top: '50%', // Center vertically
        left: '50%', // Center horizontally
        right: '50%', // Center horizontally
        transform: 'translate(-50%, -50%)', // Center both vertically and horizontally
    },
};